import { common } from '@mui/material/colors';
import { alpha } from '@mui/material/styles';

import { dark, error, indigo, info, neutral, secondary, success, warning } from '.';
import { ColorMode } from '..';

export const createPalette = (mode: ColorMode) => {

  let isDark = mode === 'dark';

  return {
    action: {
      active: neutral[500],
      disabled: alpha(neutral[900], 0.38),
      disabledBackground: alpha(neutral[900], 0.12),
      focus: alpha(neutral[900], 0.16),
      hover: alpha(neutral[900], 0.04),
      selected: alpha(neutral[900], 0.12),
    },

    background: {
      default: isDark ? dark[50] : common.white,
      paper: common.white,
    },

    divider: '#F2F4F7',
    error,
    info,
    mode,
    neutral,
    primary: indigo,
    secondary,
    success,
    warning,

    text: {
      primary: isDark ? dark[900] : neutral[900],
      secondary: neutral[500],
      disabled: alpha(neutral[900], 0.38),
    },
  };
};
